import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import PropTypes from 'prop-types';

const TableSkeleton = ({ rows = 4, columns = 4, rowHeight = 52 }) => {
  const rowKeys = Array.from({ length: rows }, (_, i) => `row-${i}`);
  const colKeys = Array.from({ length: columns }, (_, i) => `col-${i}`);

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Stack spacing={0}>
        {/* Header Skeleton */}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            px: 2,
            py: 1.5,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >
          {colKeys.map((colKey) => (
            <Skeleton
              key={`header-${colKey}`}
              variant="text"
              width={`${100 / columns}%`}
              height={30}
            />
          ))}
        </Box>

        {/* Rows Skeletons */}
        {rowKeys.map((rowKey) => (
          <Box
            key={rowKey}
            sx={{
              display: 'flex',
              gap: 2,
              px: 2,
              height: rowHeight,
              alignItems: 'center',
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            {colKeys.map((colKey) => (
              <Skeleton
                key={`${rowKey}-${colKey}`}
                variant="text"
                width={`${100 / columns}%`}
                height={24}
              />
            ))}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

TableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  rowHeight: PropTypes.number,
};

export default TableSkeleton;
